// Main JS file

// DOM ready
$(function () {
    // Object-fit polyfill
    objectFitImages();

    var $body = $('body'),
        $navToggle = $('.nav-toggle'),
        navOpenClass = 'nav-open',
        $searchToggle = $('.search-toggle'),
        $searchInput = $('.header__search .search__input'),
        searchOpenClass = 'search-open',
        searchToggleActiveClass = 'active'
    ;

    // Detect touch device
    $(window).on('touchstart', function () {
        $body.addClass('touch-device');
    });

    // Nav toggle
    function toggleNav(visible) {
        $body.toggleClass(navOpenClass, visible);
        if (visible) {
            toggleSearch(false);
        }
    }
    $navToggle.on('click', function(e) {
        toggleNav(!$body.hasClass(navOpenClass));
    });

    // Search toggle
    function toggleSearch(visible) {
        if (visible) {
            // Open search
            $body.addClass(searchOpenClass);
            setTimeout(function() {
                $searchInput.focus();
            }, 300);
            $searchToggle
                .parent('li')
                .addClass(searchToggleActiveClass);
            toggleNav(false);
        } else {
            // Close search
            $body.removeClass(searchOpenClass);
            $searchInput.blur();
            $searchToggle
                .parent('li')
                .removeClass(searchToggleActiveClass);
        }
    }
    $searchToggle.on('click', function(e) {
        toggleSearch(!$body.hasClass(searchOpenClass));
    });

    // Global Esc press
    $(document).on('keyup', function(e) {
        if (e.keyCode === 27) { // Esc
            toggleSearch(false);
            toggleNav(false);
        }
    });

    // Global click outside menu/search
    $(document).on('click touchend', function(e) {
        // Nav
        if (!$(e.target).closest('.header').length) {
            if (!$(e.target).closest('.header__nav').length) {
                toggleNav(false);
            }
            if (!$(e.target).closest('.header__search').length) {
                toggleSearch(false);
            }
        }
    });

    // Sticky aside
    (function() {
        stickyAside();

        $(window).on('resize', function(e) {
            stickyAside();
        });

        function stickyAside() {
            var $stickyContainer = $('.sticky-sidebar');

            $stickyContainer.stickySidebar({
                topSpacing: function () {
                    return ($('.header').outerHeight() + 10);
                },
                bottomSpacing: 10,
                containerSelector: '.sticky-wrapper',
                // innerWrapperSelector: '.article__aside-inner',
                minWidth: 900
            });
        }
    })();
});
